import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import Hero from "@/components/Hero";
import Features from "@/components/Features";
import HowItWorks from "@/components/HowItWorks";
import CTA from "@/components/CTA";
import Footer from "@/components/Footer";
import { AuthForm } from "@/components/auth/AuthForm";

const Index = () => {
  const navigate = useNavigate();
  const [showAuth, setShowAuth] = useState(false);
  const [session, setSession] = useState<any>(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      if (session) {
        navigate("/dashboard");
      }
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      if (session) {
        navigate("/dashboard");
      }
    });

    return () => subscription.unsubscribe();
  }, [navigate]);

  const handleTryFree = () => {
    navigate("/dashboard");
  };

  const handleSignIn = () => {
    setShowAuth(true);
  };

  if (showAuth) {
    return <AuthForm />;
  }

  return (
    <div className="min-h-screen">
      <main>
        <Hero onTryFree={handleTryFree} onSignIn={handleSignIn} />
        <Features />
        <HowItWorks />
        <CTA onGetStarted={handleSignIn} />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
